module.exports = __webpack_public_path__ + "img/list20231114003.70be7e67.png";